<template>
  <el-dialog class="registerDialog-main" :title="$t('注册')" :visible.sync="dialogVisible" @close="close"
             :close-on-click-modal="true"
             :close-on-press-escape="true">
    <el-form size="small" :model="form" ref="form" :rules="rules">
      <!--去除浏览器默认-->
      <div style="height: 0; overflow: hidden;">
        <input type="password">
      </div>
      <el-form-item :label="$t('平台名称')" :label-width="formLabelWidth" prop="app_name">
        <el-input v-model="form.app_name" autocomplete="off" :placeholder="$t('请输入平台名称')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('所在地区')" :label-width="formLabelWidth" prop="area_code">
        <el-select v-model="form.area_code" :placeholder="$t('请选择所在地区')">
          <el-option v-for="(item, i) in _countryList" :key="i" :value="item.code" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('平台账户名')" :label-width="formLabelWidth" prop="user_name">
        <el-input v-model="form.user_name" autocomplete="off" :placeholder="$t('请输入平台账户名')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('平台账户密码')" :label-width="formLabelWidth" prop="password">
        <el-input type="password" v-model="form.password" autocomplete="off" :placeholder="$t('请输入密码')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('确认密码')" :label-width="formLabelWidth" prop="password_confirm">
        <el-input type="password" v-model="form.password_confirm" autocomplete="off"
                  :placeholder="$t('请输入确认密码')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('是否连锁')" :label-width="formLabelWidth" prop="is_chain">
        <div>
          <el-radio v-model="form.is_chain" :label="1">{{ $t('是') }}</el-radio>
          <el-radio v-model="form.is_chain" :label="0">{{ $t('否') }}</el-radio>
        </div>
      </el-form-item>
      <el-form-item :label="$t('地址')" :label-width="formLabelWidth" prop="address">
        <el-input v-model="form.address" autocomplete="off" :placeholder="$t('请输入您的地址')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('联系电话')" :label-width="formLabelWidth" prop="phone">
        <el-input v-model="form.phone" autocomplete="off" :placeholder="$t('请输入您的联系电话')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('联系邮箱')" :label-width="formLabelWidth" prop="email">
        <el-input v-model="form.email" autocomplete="off" :placeholder="$t('请输入您的联系邮箱')"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('取 消') }}</el-button>
      <el-button type="primary" @click="submit" :loading="loading">{{ $t('确 定') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {countryList} from '@/utils/base.js'
import UserApi from "../../api/user";

export default {
  name: "registerDialog",
  data() {
    /*验证平台名称*/
    let checkAppName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('请输入平台名称')));
      } else {
        if (this.$filter.isAllSpace(value)) {
          return callback(new Error(this.$t('不能全是空格')));
        } else {
          callback();
        }
      }
    };
    /*验证平台账户名*/
    let checkUsername = (rule, value, callback) => {
      if (!this.$filter.replaceSpace(value)) {
        return callback(new Error(this.$t('平台账户名')));
      } else {
        if (this.$filter.hasSpace(value)) {
          return callback(new Error(this.$t('不能包含空格')));
        } else {
          callback();
        }
      }
    };
    /*密码验证*/
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('请输入密码')));
      } else {
        if (this.$filter.hasSpace(value)) {
          return callback(new Error(this.$t('不能包含空格')));
        } else if (value.length < 6) {
          return callback(new Error(this.$t('长度不能小于6位')));
        } else {
          callback();
        }
      }
    };
    /*确认新密码验证*/
    let checkPasswordConfirm = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('请填写确认密码')));
      } else if (value !== this.form.password) {
        callback(new Error(this.$t('确认密码不一致')));
      } else {
        callback();
      }
    };
    /*所在地区选择*/
    let checkAreaCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('请选择所在地区')));
      } else {
        callback();
      }
    };
    /*地址验证*/
    let checkAddress = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('请输入您的地址')));
      } else {
        callback();
      }
    };
    /*联系电话验证*/
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('请输入您的联系电话')));
      } else {
        callback();
      }
    };
    /*邮箱验证*/
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('请输入您的联系邮箱')));
      } else {
        // 使用正则表达式来验证邮箱格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          callback(new Error(this.$t('请输入有效的邮箱地址')));
        } else {
          callback();
        }
      }
    };


    return {
      dialogVisible: false,
      loading: false,
      form: {
        app_name: '',
        user_name: '',
        password: '',
        password_confirm: '',
        area_code: '',
        is_chain: 1,
      },
      /*验证规则*/
      rules: {
        app_name: [{
          validator: checkAppName,
          required: true,
          trigger: 'blur'
        }],
        user_name: [{
          validator: checkUsername,
          required: true,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          required: true,
          trigger: 'blur'
        }],
        password_confirm: [{
          validator: checkPasswordConfirm,
          required: true,
          trigger: 'blur'
        }],
        area_code: [{
          required: true,
          trigger: 'change',
          validator: checkAreaCode,
        }],
        address: [{
          required: true,
          trigger: 'blur',
          validator: checkAddress,
        }],
        phone: [{
          required: true,
          trigger: 'blur',
          validator: checkPhone,
        }],
        email: [{
          required: true,
          trigger: 'blur',
          validator: checkEmail,
        }],
      },
      countryCode: '',
      formLabelWidth: '120px',
    }
  },
  computed: {
    _countryList() {
      return countryList
    }
  },
  methods: {
    close(done) {
      if (typeof done === 'function') {
        done()
      }
      this.dialogVisible = false
    },

    open() {
      this.dialogVisible = true
      if (!this.form.country) {
        // 地区没有信息的话自动填入
        let code = this.countryCode
        let _country = countryList.find((item) => {
          return item.ids.includes(code)
        })
        if (_country) {
          this.form.area_code = _country.code
        }
      }
    },

    async handleGetIp() {
      return new Promise((resolve) => {
        let request = new XMLHttpRequest();
        request.open('GET', 'https://api.ipify.org?format=json', true);
        request.onload = function () {
          if (request.status >= 200 && request.status < 400) {
            let data = JSON.parse(request.responseText);
            resolve(data.ip)
          }
        };
        request.onerror = function () {
          console.error('Error occurred during the network request');
          resolve('')
        };
        request.send();
      })
    },

    async getIpLocation() {
      let _ip = await this.handleGetIp()
      if (!_ip) {
        // 第一步出错了就不找了
        return
      }
      let request = new XMLHttpRequest();
      request.open('GET', `http://ip-api.com/json/${_ip}`, true);
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          let data = JSON.parse(request.responseText);
          console.log(data.countryCode)
          this.countryCode = data.countryCode
          // resolve('2.16.16.255')
        }
      };
      request.onerror = function () {

      };
      request.send();
    },
    async submit() {
      let self = this;
      if (self.loading) {
        return;
      }
      let params = self.form;
      self.loading = true;
      try {
        let res = await UserApi.register(params);
        if (res && res.code === 1) {
          self.$message({
            message: self.$t('注册成功,请前往登录'),
            type: 'success'
          });
          setTimeout(() => {
            self.close();
          }, 1000);
        }
      } catch (error) {
        console.error('Registration failed:', error);
        // this.$message.error(this.$t('注册失败，请重试'));
      } finally {
        self.loading = false; // 无论成功还是失败，都要确保 loading 被重置
      }
    }
  },
  async mounted() {
    // await this.getIpLocation()
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/login/registerDialog.vue